import { useContext } from 'react';
import { createNamedContext } from '@utils';
import { ProfileContext } from './interfaces';

export const ProfileEmploymentFormContext = createNamedContext<ProfileContext.EmploymentFormContextValue>(undefined, 'ProfileEmploymentFormContext');
export const ProfileEducationFormContext = createNamedContext<ProfileContext.EducationFormContextValue>(undefined, 'ProfileEducationFormContext');

export const useProfileEmploymentForm = () => useContext(ProfileEmploymentFormContext);
export const useProfileEducationForm = () => useContext(ProfileEducationFormContext);